import { ButtonSize } from 'shared/newEntities/components/Button';

import { AppNotificationType } from '../appNotifications';
import { ComponentType } from '../components/Component';
import type { IAppNotificationsStore } from '../store/appNotificationsStore';

export enum WidgetState {
  idle = 'idle',
  anonymous = 'anonymous',
  manager = 'manager',
  paused = 'paused',
  restoring = 'restoring',
  disposed = 'disposed'
}

export const WIDGET_AUTH_UNAVAILABLE_ERROR_CODES = [
  'channel_not_found',
  'channel_disabled'
] as const;

export const openWidgetAuthorizationError = (
  appNotificationsStore: IAppNotificationsStore,
  onRetry: () => void
): void => {
  appNotificationsStore.open({
    type: AppNotificationType.error,
    title: (t) =>
      t('WidgetSupport.notifications.authorizationError', { ns: 'stores' }),
    button: {
      type: ComponentType.button,
      size: ButtonSize.sm,
      children: (t) =>
        t('WidgetSupport.notifications.retryAuthorization', { ns: 'stores' }),
      onClick: onRetry
    },
    timeout: 10000
  });
};

export const openWidgetTestingError = (
  appNotificationsStore: IAppNotificationsStore
): void => {
  appNotificationsStore.open({
    type: AppNotificationType.error,
    title: (t) =>
      t('WidgetSupport.notifications.testingError', { ns: 'stores' }),
    timeout: 10000
  });
};
